module.exports = __webpack_public_path__ + "4bf5ffb3d80031e6b05e957960b360c3.pdf";